var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",attrs:{"id":"box"},on:{"mouseover":_vm.boxMouseover,"mouseleave":_vm.boxMouseleave}},[_c('div',{staticClass:"title",class:_vm.direction ? 'left' : 'right'},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content",class:_vm.direction ? 'left-content' : 'right-content'},[_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }